/**
 * Where focus should go next within a single vertical list of controls, such as
 * the checkbox options inside a filter's popup.
 *
 * Clamps at both ends rather than wrapping: in a short visible list, jumping from
 * the last item back to the first reads as a glitch rather than as movement.
 *
 * @param {number|null} index - position of the focused control, or null when
 *   focus has not entered the list yet (it sits on the popup as it opens)
 * @param {'up'|'down'|'left'|'right'} direction
 * @param {number} count - controls in the list
 * @returns {number|null} index to focus, or null to leave the key alone
 */
export const nextIndexInList = ({ index = null, direction, count = 0 } = {}) => {
    if (count === 0) return null;
    if (direction !== 'up' && direction !== 'down') return null;

    // Entering the list from outside: down starts at the top, up starts at the bottom.
    if (index === null || index < 0) return direction === 'down' ? 0 : count - 1;

    return direction === 'down'
        ? Math.min(count - 1, index + 1)
        : Math.max(0, index - 1);
};
